import moment from 'moment';
import { useResolution886Report } from '@/context/Resolution886Report';
import { useGetListGeneralResults } from '@/hooks/v2/resolution-886';

export const useGetGeneralComment = () => {
	const { report } = useResolution886Report();
	const locale = moment.locale();

	const { data: generalResults } = useGetListGeneralResults({
		report_id: report?.id,
		company_id: report?.company?.id,
		organization_id: report?.organization?.id,
		locale: locale
	});

	const comment = generalResults?.comment;

	return { comment };
};
